<template>
  <div class="full-h-view d-flex flex-column justify-content-between h-100">
    <div
      class="nav-header d-flex justify-content-end align-items-center py-1 pe-1"
    >
      <span
        class="material-symbols-outlined p-2_5 close-view"
        @click="handleClose"
        >close</span
      >
    </div>
    <div class="content-container">
      <div
        class="mx-4 d-flex flex-grow-1 flex-column justify-content-center align-items-center text-center"
      >
        <div class="flex-grow-1"></div>
        <div class="mb-3">
          <div class="error-icon-container">
            <span class="material-symbols-outlined error-icon">error</span>
          </div>
        </div>
        <div class="error-title mb-2">
          {{ errorTitle ? t(errorTitle) : t("ADD_ONS.ERROR_TITLE") }}
        </div>
        <div class="error-description mb-3">
          {{
            errorDescription
              ? t(errorDescription)
              : t("ADD_ONS.ERROR_DESCRIPTION")
          }}
        </div>
        <div class="device-id-info mb-4" v-if="deviceId">
          <span class="device-id-label">{{ t("ADD_ONS.DEVICE_ID") }}</span>
          <span class="device-id-value">{{ deviceId }}</span>
        </div>
        <div class="flex-grow-1"></div>
      </div>
    </div>
    <div class="mx-3 my-2_5 add_on-cta-btn-container">
      <Button
        id="btn-submit"
        class="fw-bolder add_on-confirmation-btn"
        @click="handleTryAgain"
      >
        {{ t("ADD_ONS.TRY_AGAIN") }}
      </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import Button from "@/apps/credit-line/components/Button.vue";

interface Props {
  errorTitle?: string;
  errorDescription?: string;
  deviceId?: string;
  onTryAgain?: () => void;
  onClose?: () => void;
}

const props = withDefaults(defineProps<Props>(), {
  errorTitle: "",
  errorDescription: "",
  deviceId: "",
  onTryAgain: undefined,
  onClose: undefined,
});

const { t } = useI18n();

const handleClose = () => {
  if (props.onClose) {
    props.onClose();
  }
};

const handleTryAgain = () => {
  if (props.onTryAgain) {
    props.onTryAgain();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_spacing-utils.scss";

.full-h-view {
  min-height: 100dvh;
}

.nav-header {
  height: 3.5rem;
}

.close-view {
  color: #1c1b1f;
}

.content-container {
  position: fixed;
  top: 3.5rem;
  bottom: 4.5rem;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
}

.error-icon-container {
  width: 64px;
  height: 64px;
  border-radius: 32px;
  background-color: #ffe4e6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.error-icon {
  font-size: 32px;
  color: #dc3545;
}

.error-title {
  font-size: 1.5rem;
  line-height: 2.5rem;
  font-weight: 600;
  font-family: Inter;
  color: #111;
  text-align: center;
}

.error-description {
  font-size: 0.875rem;
  line-height: 1.5rem;
  font-weight: 500;
  font-family: Inter;
  color: #595a5a;
  text-align: center;
}

.device-id-info {
  font-size: 0.875rem;
  line-height: 1.5rem;
  font-family: Inter;
  color: #8b8b8b;
}

.device-id-label {
  font-weight: 500;
}

.device-id-value {
  font-weight: 400;
  margin-left: 0.25rem;
}

.add_on-confirmation-btn {
  border-radius: 0.313rem;
  background-color: #007c3b;
}

.add_on-cta-btn-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
